import {
	createFileRoute,
	Link,
	Outlet,
	useMatches,
	useRouterState,
} from "@tanstack/react-router";
import { PublicFooter, PublicHeader } from "@/components/public-layout";

export const Route = createFileRoute("/blog")({
	component: BlogLayout,
});

function BlogLayout() {
	const matches = useMatches();
	const pathname = useRouterState({
		select: (state) => state.location.pathname,
	});
	const lastMatch = matches[matches.length - 1];
	const isIndex =
		lastMatch?.fullPath === "/blog" || lastMatch?.fullPath === "/blog/";
	const slug = decodeURIComponent(
		pathname.replace(/^\/blog\/?/, "").replace(/\/$/, ""),
	);
	const articleTitle = (
		lastMatch?.loaderData as { article?: { title?: string } } | undefined
	)?.article?.title;
	const crumbLabel = articleTitle ?? slug;

	return (
		<div className="flex min-h-svh flex-col bg-background text-foreground">
			<PublicHeader />
			<main className="relative z-10 flex-1">
				<div className="mx-auto max-w-6xl px-4 sm:px-6">
					<div className="marketing-line-stack flex flex-col overflow-hidden divide-y divide-border">
						{/* Content */}
						<div className="rounded-md bg-white dark:bg-black px-6 py-10 sm:px-8 sm:py-12">
							<div className="mx-auto max-w-2xl">
								{!isIndex ? (
									<nav
										aria-label="Breadcrumb"
										className="mb-6 text-base text-muted-foreground"
									>
										<ol className="flex flex-wrap items-center gap-1.5">
											<li>
												<Link
													to="/"
													className="transition-colors hover:text-foreground"
												>
													Home
												</Link>
											</li>
											<li aria-hidden="true" className="text-muted-foreground">
												/
											</li>
											<li>
												<Link
													to="/blog"
													className="transition-colors hover:text-foreground"
												>
													Blog
												</Link>
											</li>
											<li aria-hidden="true" className="text-muted-foreground">
												/
											</li>
											<li aria-current="page" className="text-foreground">
												{crumbLabel}
											</li>
										</ol>
									</nav>
								) : null}
								<Outlet />
								{!isIndex && (
									<div className="mt-10">
										<Link
											to="/blog"
											className="text-sm text-muted-foreground hover:text-foreground transition-colors"
										>
											&larr; All articles
										</Link>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</main>
			<PublicFooter />
		</div>
	);
}
